import React, { useEffect, type FC, useState } from 'react'

import UserStateProvider from 'fk-ui-common/providers/UserStateProvider'
import { changeToolBarVisibility } from 'fk-ui-common/utils/bridgeCaller'
import AppRouter from 'AppRouter'
import AppProvider from 'AppProvider'
import ModalProvider from 'providers/ModalProvider'
import SnackbarProvider from 'providers/SnackbarProvider'
import platform, { isMobile } from 'helpers/platform'
import { TENANT } from 'constants.app'
import { getUserSessionData, getUserLoggedInStatus } from 'helpers/utils'
import Desktop from 'pages/Desktop'
import { getTopSafeAreaForCustomToolBar } from 'pages'
import { newRelic } from './observability/NewRelic'
import { NRAttributes } from './observability/NewRelicEvents'

// Adding this in BottomSheet component is giving webpack error
import 'react-spring-bottom-sheet/dist/style.css'

const App: FC = () => {
  const [isDesktop, setIsDesktop] = useState(platform?.isDesktop)

  useEffect(() => {
    window.addEventListener('resize', checkForDesktop)
    return () => {
      window.removeEventListener('resize', checkForDesktop)
    }
  }, [])

  useEffect(() => {
    const session = getUserSessionData()
    newRelic?.setCustomAttribute(NRAttributes.TENANT_NAME, TENANT)
    newRelic?.setCustomAttribute(NRAttributes.IS_LOGGED_IN, getUserLoggedInStatus())
    session?.accountId !== undefined &&
      newRelic?.setCustomAttribute(NRAttributes.ACCOUNT_ID, session.accountId)
  }, [])

  useEffect(() => {
    void changeToolBarVisibility(true, getTopSafeAreaForCustomToolBar(window.location.pathname))
  }, [])

  const checkForDesktop = (): void => {
    setIsDesktop(!isMobile())
  }

  return (
    // *https://blog.bitsrc.io/react-v18-0-useeffect-bug-why-do-effects-run-twice-39babecede93
    <React.StrictMode>
      <UserStateProvider tenantName={TENANT}>
        <ModalProvider>
          <AppProvider>
            <SnackbarProvider>{isDesktop ? <Desktop /> : <AppRouter />}</SnackbarProvider>
          </AppProvider>
        </ModalProvider>
      </UserStateProvider>
    </React.StrictMode>
  )
}

export default App
